var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-app"},[_c('GetApp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }